import { ErrorMapping } from 'core/types/error-mapping';
import { GraphqlError } from 'core/utils/backend-service';
import {
    EapSettingsCreateModel,
    EapSettingsFormModelValidationModel,
} from 'modules/settings/pods/settings-devices/settings-devices-eap-settings/settings-devices-eap-settings-form/settings-devices-eap-settings-form.model';

const COPY_FORM_ERRORS_MAPPINGS: ErrorMapping<string, keyof EapSettingsCreateModel>[] = [
    { field: 'name', errorCode: 'E_POC_ADM_DM_0146', type: 'value-missing' },
    { field: 'name', errorCode: 'E_POC_ADM_DM_0147', type: 'value-missing' },
    { field: 'name', errorCode: 'E_POC_ADM_DM_0148', type: 'too-long' },
    { field: 'name', errorCode: 'E_POC_ADM_DM_0155', type: 'duplicated' },
    { field: 'ssid', errorCode: 'E_POC_ADM_DM_0149', type: 'value-missing' },
    { field: 'ssid', errorCode: 'E_POC_ADM_DM_0150', type: 'too-long' },
    { field: 'username', errorCode: 'E_POC_ADM_DM_0139', type: 'value-missing' },
    { field: 'username', errorCode: 'E_POC_ADM_DM_0140', type: 'value-missing' },
    { field: 'password', errorCode: 'E_POC_ADM_DM_0125', type: 'value-missing' },
    { field: 'password', errorCode: 'E_POC_ADM_DM_0135', type: 'value-missing' },
];

export const mapApiErrorsToValidityErrors = (errors: GraphqlError[]): EapSettingsFormModelValidationModel => {
    const errorType = Object.entries(COPY_FORM_ERRORS_MAPPINGS)
        .filter(([, mapping]) => errors?.some((e) => e.extensions.code === mapping.errorCode))
        .map(([, mapping]) => ({ [mapping.field as string]: { state: 'error', type: [mapping.type] } }))
        .reduce((acc, curr) => ({ ...acc, ...curr }), {});
    return errorType;
};
